import { ApiError } from "./api.ts";

/**
 * Converte qualquer erro (ApiError, falha de rede, etc.) numa mensagem curta e
 * amigável em português. O backend já devolve textos claros em `erro` — usamos
 * esses quando existem; senão, traduzimos por status. Falha de rede (o `fetch`
 * nem completa) não é ApiError → cai em "sem conexão".
 */
export function mensagemAmigavel(e: unknown, padrao = "Algo deu errado. Tente novamente."): string {
  if (e instanceof ApiError) {
    if (e.message?.trim()) {
      return e.message;
    }
    switch (e.status) {
      case 400:
        return "Dados inválidos. Confira o que foi preenchido.";
      case 401:
        return "Sua sessão expirou. Saia e entre novamente.";
      case 403:
        return "Você não tem permissão para esta ação.";
      case 404:
        return "Registro não encontrado.";
      case 409:
        return "Já existe um registro com esses dados.";
      default:
        return e.status >= 500 ? "O servidor falhou. Tente novamente em instantes." : padrao;
    }
  }
  // fetch rejeitado (offline/DNS/CORS) lança TypeError, não ApiError.
  return "Sem conexão. Verifique sua internet e tente de novo.";
}
